<app-row-layout [rowData]="footerRow" [rowStyle]="'footer'"></app-row-layout>
